import { v4 as uuidv4 } from "uuid";

export const makeId: () => string = () => {
  return uuidv4();
};
